import React, { useEffect } from 'react';

interface GlobalErrorProps {
    message: string;
    onClose: () => void;
    duration?: number;
}

export const GlobalErrorDisplay: React.FC<GlobalErrorProps> = ({ message, onClose, duration = 5000 }) => {
    useEffect(() => {
        if (duration > 0) {
            const t = setTimeout(onClose, duration);
            return () => clearTimeout(t);
        }
    }, [duration, onClose]);

    return (
        <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[99999] animate-fade-in-down w-[90%] max-w-lg">
            <div className="bg-red-600/90 backdrop-blur-md text-white px-6 py-4 rounded-2xl shadow-[0_10px_40px_rgba(220,38,38,0.4)] border border-red-500/50 flex items-start gap-4">
                <div className="text-2xl">⚠️</div>
                <div className="flex-1">
                    <h4 className="text-xs font-black uppercase tracking-widest mb-1">Erreur Système</h4>
                    <p className="text-sm font-medium leading-snug opacity-90">{message}</p>
                </div>
                <button 
                    onClick={onClose}
                    className="p-1 hover:bg-white/20 rounded-full transition-colors"
                >
                    ✕
                </button>
            </div>
        </div>
    );
};
